import axios from 'axios'
import qs from 'qs'
import {
    Message,
    MessageBox,
    Loading
} from 'element-ui'
import store from '../store'
import {
    getToken
} from '@/utils/auth'

let loading        //定义loading变量

function startLoading() {    //使用Element loading-start 方法
    loading = Loading.service({
        lock: true,
        text: '加载中...',
        background: 'rgba(0, 0, 0, 0.7)'
    })
}
function endLoading() {    //使用Element loading-close 方法
    loading.close()
}

let service = axios.create({
    timeout:500000,//响应时间
    // baseURL:'',//配置接口地址
})

service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

service.defaults.withCredentials=true;
// request拦截器
axios.interceptors.request.use(config => {
    console.log(config);
    // 加载
    startLoading()
    console.log("request拦截器")
    console.log("sessionid:"+getToken('Admin-Token'));
    if (getToken('Admin-Token')) {
        config.headers = {
            'JSESSIONID': getToken('Admin-Token'), //携带权限参数
        };
    }
    return config
}, error => {
    console.log("request拦截器:"+error);
    Promise.reject(error)
})
// respone拦截器
axios.interceptors.response.use(
    response => {
        /**
         * code:200,接口正常返回;
         */
        endLoading()
        console.log("response:"+response);
        const res = response.data
        console.log(res);
        if (res.code !== 200) {
            Message({
                message: res.msg,
                type: 'error',
                duration: 5 * 1000
            })
            // 根据服务端约定的状态码：5001:非法的token; 5002:其他客户端登录了; 5004:Token 过期了;
            if (res.code === 201 || res.code === 403) {
                MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
                    confirmButtonText: '重新登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    console.log("logout");
                    store.dispatch('LogOut').then(() => {
                        location.reload() // 为了重新实例化vue-router对象 避免bug
                    })
                })
            }
            return Promise.reject('error')
        } else { // res.code === 200,正常返回数据
            return response.data
        }
    },
    error => {
        Message({
            message: error.msg,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service